import React, { useState, useEffect } from "react";

import { Row, Col } from "react-bootstrap";

import { useMultiFilterContext } from "contexts/MultiFilterContext";

export default function FilterGroupTitle({ filterGroup }) {
  const { dispatch, actions, state } = useMultiFilterContext();

  const selectSubCategory = () => {
    actions.selectSubCategory(dispatch, filterGroup.subcategory);
  };

  const deselectSubCategory = () => {
    actions.deselectSubCategory(dispatch, filterGroup.subcategory);
  };

  return (
    <Row>
      <Col md={6}>
        <h2>{filterGroup.title}</h2>
      </Col>
      <Col md={6} className="text-right">
        <a onClick={selectSubCategory} className="select-all-block">
          Select All
        </a>
        <a onClick={deselectSubCategory} className="unselect-all-block">
          Deselect All
        </a>
      </Col>
    </Row>
  );
}
